export const UIGraphicsState={
    None:0,
    Start:1,
    Drawing:2,
    End:3,
    Error:4
};
